import { useState, useEffect } from 'react';

interface GMBLockedDashboardProps {
  onConnect: () => void;
  darkMode: boolean;
}

export default function GMBLockedDashboard({
  onConnect,
  darkMode,
}: GMBLockedDashboardProps) {
  const [bannerDismissed, setBannerDismissed] = useState(() => {
    return sessionStorage.getItem('gmb_banner_dismissed') === 'true';
  });

  useEffect(() => {
    if (bannerDismissed) {
      sessionStorage.setItem('gmb_banner_dismissed', 'true');
    } else {
      sessionStorage.removeItem('gmb_banner_dismissed');
    }
  }, [bannerDismissed]);

  return (
    <div className="space-y-6">
      {!bannerDismissed && (
        <div
          className={`rounded-xl border p-6 ${
            darkMode
              ? 'bg-gray-800 border-gray-700'
              : 'bg-white border-gray-200'
          }`}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-start gap-4">
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${
                  darkMode ? 'bg-amber-900/30' : 'bg-amber-50'
                }`}
              >
                <i className="ri-lock-line text-2xl text-amber-600"></i>
              </div>
              <div>
                <h3
                  className={`text-lg font-semibold mb-1 ${
                    darkMode ? 'text-white' : 'text-gray-900'
                  }`}
                >
                  GMB Manager is locked
                </h3>
                <p
                  className={`text-sm ${
                    darkMode ? 'text-gray-400' : 'text-gray-500'
                  }`}
                >
                  Connect your Google Business Profile to unlock Strategy,
                  Implementation, Governance, and Optimization features.
                </p>
              </div>
            </div>
            <button
              onClick={() => setBannerDismissed(true)}
              className={`p-1 rounded-lg transition-colors ${
                darkMode
                  ? 'text-gray-400 hover:bg-gray-700 hover:text-gray-300'
                  : 'text-gray-400 hover:bg-gray-100 hover:text-gray-600'
              }`}
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>

          <div className="mt-4 ml-16">
            <button
              onClick={onConnect}
              className="px-4 py-2 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold transition-colors flex items-center gap-2"
            >
              <i className="ri-links-line"></i>
              Connect GMB
            </button>
          </div>
        </div>
      )}

      {bannerDismissed && (
        <div className="flex items-center justify-center min-h-[300px]">
          <div className="text-center">
            <div
              className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 ${
                darkMode ? 'bg-gray-800' : 'bg-gray-100'
              }`}
            >
              <i
                className={`ri-lock-line text-3xl ${
                  darkMode ? 'text-gray-500' : 'text-gray-400'
                }`}
              ></i>
            </div>
            <p
              className={`text-sm mb-4 ${
                darkMode ? 'text-gray-400' : 'text-gray-500'
              }`}
            >
              Connect your GMB account to get started
            </p>
            <button
              onClick={onConnect}
              className="px-4 py-2 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold transition-colors flex items-center gap-2 mx-auto"
            >
              <i className="ri-links-line"></i>
              Connect GMB
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
